<template>
  <div>
<v-card v-if="!readyTransaction">
  <v-card-title> Initiating a stake transaction. </v-card-title>
  <v-card-subtitle>
    Stake in {{data.fund.title}} <br/>
    of project {{data.proj.title}}
 </v-card-subtitle>
  <v-card-text>
    <SchemaForm  :model="data.stake" item="stake" v-on:save="ready" v-on:cancel="cancel"/>
  </v-card-text>

</v-card>

<v-card v-if="readyTransaction">
  <v-card-title> Initiating a stake transaction. </v-card-title>
  <v-card-text>

      <div>
      <span class="label">Note: </span>
      <span class="value">{{data.stake.title}}</span>
      </div>

      <div>
      <span class="label">Amount: </span>
      <span class="value">{{data.stake.amount | currency}}</span>
      </div>

    </v-card-text>
</v-card>
<v-card v-if="readyTransaction">
    <BrainTreeEZ :stake="data.stake" v-if="readyTransaction"/>
</v-card>

  </div>
</template>

<script>
import router from '../plugins/router'
//import Content from './Content.vue'
import BrainTreeEZ from './BrainTreeEZ.vue'
//const log = console.log
import SchemaForm from './SchemaForm.vue'

export default {
  name: 'Refund',
  data : function() {
      return {
          config: {
              schema: {}
          },
          data: {
              proj : {},
              fund : {},
              stake : {}
          },
          readyTransaction : false
      }
  },
  created: function() {
      this.data.proj = this.$route.params.proj || {}
      this.data.fund = this.$route.params.fund || {}
      this.data.stake.title = "Stake in " + this.data.fund.title + " : " + this.data.proj.title
      if (!this.data.fund.uuid) {
           router.push({ name: 'Projects' })
      }
  },
  components: {
//      Content,
      BrainTreeEZ,
      SchemaForm
  },
  props: {
  },
  methods: {
      ready(d) {
            //var self = this
            //var stake = self.data.stake
            this.data.stake = {
                ...this.data.stake,
                ...d,
                _parent: this.data.fund.uuid,
                project: this.data.proj.uuid,
            }

            this.readyTransaction = true

      },
      cancel() {
           router.push({ name: 'Project', params: {
               uuid: this.$store.getters.route_projId
           } })
      }
  }
}
</script>

<style scoped>
.label { 
    margin-left: none;
    margin-right: none;
    text-align: left;
    font-weight: bold;
}
</style>
